import { useMemo } from 'react';
import { OrderDeliveryMethods, type OrderDeliveryOptions } from '@/shared/api/order';
import { useOptionAvailability } from './useOptionAvailability';

export const useDeliveryOptions = (options: OrderDeliveryOptions) => {
    const optionPickup = options?.deliveryMethods.pickupPoint;
    const optionCourier = options?.deliveryMethods.courier;
    const optionSelf = options?.deliveryMethods.selfPickupPoint;

    const isPickupAvailable = useOptionAvailability(optionPickup);
    const isCourierAvailable = useOptionAvailability(optionCourier);
    const isSelfPickupAvailable = useOptionAvailability(optionSelf);

    return useMemo(
        () => [
            {
                key: OrderDeliveryMethods.PICKUP_POINT,
                title: 'Пункт выдачи',
                option: optionPickup,
                isAvailable: isPickupAvailable,
            },
            {
                key: OrderDeliveryMethods.COURIER,
                title: 'Курьер',
                option: optionCourier,
                isAvailable: isCourierAvailable,
            },
            {
                key: OrderDeliveryMethods.SELF_PICK_UP,
                title: 'Самовывоз',
                option: optionSelf,
                isAvailable: isSelfPickupAvailable,
            },
        ],
        [optionPickup, optionCourier, optionSelf, isPickupAvailable, isCourierAvailable, isSelfPickupAvailable]
    );
};
